module.exports = __webpack_public_path__ + "static/media/Relic-client.d76d1d26.png";